import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Entrepreneurship() {
  const menu = [
    {
      name: "1. Why did we opt for commercializing BioRocket?",
      id: "Entrepreneurship-0",
    },
    {
      name: "2. Our company",
      id: "Entrepreneurship-1",
    },
    {
      name: "3. Why now?",
      id: "Entrepreneurship-2",
    },
    {
      name: "4. Why us?",
      id: "Entrepreneurship-3",
    },
    {
      name: "5. Business plan",
      id: "Entrepreneurship-4",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Entrepreneurship:</p>
        <p
          className="subtitle"
          key={"Entrepreneurship-0"}
          id="Entrepreneurship-0"
        >
          1. Why did we opt for commercializing BioRocket?
        </p>
        <ContentCard
          content={` 
            <p>
            There are various approaches to advancing a project, such as treating it as a research endeavor or transferring patents to large corporations. Why did we opt for the commercialization of BioRocket?
            </p>
            <br/>
            <p>
            Therapeutic protein delivery is a bottleneck issue in modern medicine, and we aim to rescue the lives of countless patients by developing innovative delivery platforms. Within BioRocket, aside from our algorithms, the presence of a high-throughput experimental validation platform is equally crucial. In comparison to academia, the industry already possesses relatively mature large-scale experimental platforms. This will be the linchpin of BioRocket's success and represents our fundamental requirement for seeking financing.
            </p>
              `}
        />
        <p
          className="subtitle"
          key={"Entrepreneurship-1"}
          id="Entrepreneurship-1"
        >
          2. Our company
        </p>
        <ContentCard
          content={` 
            <p>
            BioRocket is a platform-based service company in the field of computational biology, with a dedicated focus on addressing the protein delivery domain. We are committed to developing extracellular Contractile Injection Systems (eCISs) using algorithms and high-throughput experimental techniques to enable their broader application in both research and clinical settings.
            </p>
            <br/>
            <img
            src='https://static.igem.wiki/teams/4826/wiki/entrepreneur-figure1.png'
            alt='Figure 1. Roadmap of BioRocket'
            class='content-figure'
            />
            <p class='content-legend'>
            Figure 1. Roadmap of BioRocket
            </p>
            `}
        />
        <p
          className="subtitle"
          key={"Entrepreneurship-2"}
          id="Entrepreneurship-2"
        >
          3. Why now?
        </p>
        <ContentCard
          content={` 
            <p>
            In the traditional research paradigm, a universal technology has not yet been identified in the field of protein delivery. In recent years, with the development of genomic data, innovation in biology is increasingly being driven by software and data. We have observed revolutionary advancements in three domains: synthetic biology, artificial intelligence, and experimental platform automation. By utilizing computational methods and high-throughput wet lab experiments, BioRocket can fully harness the programmable potential of eCISs in the natural world, constructing a new, versatile protein delivery platform.
            </p>
              `}
        />
        <p
          className="subtitle"
          key={"Entrepreneurship-3"}
          id="Entrepreneurship-3"
        >
          4. Why us?
        </p>
        <ContentCard
          content={` 
            <p>
            Protein delivery is a multidisciplinary challenge that requires a diverse set of expertise. BioRocket boasts an interdisciplinary team with members possessing backgrounds in biology, medicine, computer science, mathematics, and business. Additionally, our advisory board brings extensive experience in computational biology and wet lab experiments, and we maintain strong relationships with hospitals and biotechnology companies.
            </p>
              `}
        />
        <p
          className="subtitle"
          key={"Entrepreneurship-4"}
          id="Entrepreneurship-4"
        >
          5. Business plan
        </p>
        <ContentCard
          content={` 
            <p>
            We have crafted a business plan that provides a detailed exposition of BioRocket's objectives, vision, and avenues for realization. Within this plan, we have conducted an in-depth analysis of factors such as the market, technological pathways, and potential risks.
            </p>
            <br/>
            <p>
            Scroll in the preview below or download the PDF of our business plan.
            </p>
            <br/>
            <iframe width="100%" height="900px" src="https://static.igem.wiki/teams/4826/wiki/business-plan-for-biorocket.pdf"></iframe>
              `}
        />
      </div>
      <Footer />
    </div>
  );
}
